import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {makeNavbarBackgroundStyles} from 'nav/navbar/NavBarColor';

import * as SidepanelActions from '../sidepanel/SidepanelActions';
import HomeIcon from './HomeIcon';
import {navBarContentsStyles} from './NavBarContents';

export default function SignedOutNavBarContents(): JSX.Element {
  return (
    <div
      className={classNames(css(navBarContentsStyles.navbar), 'js-navTour-nav')}
      style={makeNavbarBackgroundStyles(false)}
    >
      <HomeIcon
        icon="benchling"
        isActive={true}
        onHomeIconClick={(e, section) => {
          SidepanelActions.unexpandToSection(section);
        }}
      />
    </div>
  );
}
